webpackJsonp([0],Array(38).concat([
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(167),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Products__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Locations__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Locations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Locations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buyer__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Buyer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Buyer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_User__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UserAccount__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UserAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_UserAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Cart__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UserSidebar__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UserSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_UserSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Supplier__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Supplier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Supplier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AccountSelection__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AccountSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_AccountSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SupplierProductProposal__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SupplierProductProposal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_SupplierProductProposal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SupplierProducts__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SupplierProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_SupplierProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SupplierProduct__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_SupplierProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_SupplierProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AdminProposal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AdminProposal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_AdminProposal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdminPurchase__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdminPurchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_AdminPurchase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdminSuppliers__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdminSuppliers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_AdminSuppliers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdminSupplierItems__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AdminSupplierItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_AdminSupplierItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AdminProducts__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_AdminProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_AdminProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_PageNotFound__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_PageNotFound__);












/*START USER*/


 //tester

/*END USER*/
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//Components go here


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
    }, {
        path: '/about',
        name: 'About',
        component: __WEBPACK_IMPORTED_MODULE_3__components_About___default.a
    }, {
        path: '/products',
        name: 'Products',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Products___default.a
    },
    //product code
    {
        path: '/products/product/:productcode',
        name: 'Product',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Product___default.a
    }, {
        path: '/locations',
        name: 'Locations',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Locations___default.a
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Login___default.a
    },
    ///////// experiments 
    {
        path: '/registration/buyer',
        name: 'RegistrationBuyer',
        component: __WEBPACK_IMPORTED_MODULE_8__components_Buyer___default.a
    }, {
        path: '/registration/supplier',
        name: 'RegistrationSupplier',
        component: __WEBPACK_IMPORTED_MODULE_13__components_Supplier___default.a
    },
    ///////// experiments
    {
        path: '/account-selection',
        name: 'AccountSelection',
        component: __WEBPACK_IMPORTED_MODULE_14__components_AccountSelection___default.a
    },
    //START of users ----------------------
    //purchases
    {
        path: '/user',
        name: 'User',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_9__components_User___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_12__components_UserSidebar___default.a
        }
    },
    //account information
    {
        path: '/useraccount',
        name: 'UserAccount',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_10__components_UserAccount___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_12__components_UserSidebar___default.a
        }
    },
    //cart
    {
        path: '/cart',
        name: 'UserCart',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_11__components_Cart___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_12__components_UserSidebar___default.a
        }
    },
    //cart
    //END of users ----------------------
    {
        path: '/supplierproductproposal',
        name: 'SupplierProductProposal',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_15__components_SupplierProductProposal___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar___default.a
        }
    }, {
        path: '/supplierproducts',
        name: 'SupplierProducts',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_17__components_SupplierProducts___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar___default.a
        }
    }, {
        //this is a test component to be merged later
        path: '/supplierproduct',
        name: 'SupplierProduct',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_18__components_SupplierProduct___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_16__components_SupplierSidebar___default.a
        }
    }, {
        path: '/adminproposal',
        name: 'AdminProposal',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_20__components_AdminProposal___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default.a
        }
    }, {
        path: '/adminpurchase',
        name: 'AdminPurchase',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_21__components_AdminPurchase___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default.a
        }
    }, {
        path: '/adminsuppliers',
        name: 'AdminSuppliers',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_22__components_AdminSuppliers___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default.a
        }
    }, {
        path: '/adminsupplieritems',
        name: 'AdminSupplierItems',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_23__components_AdminSupplierItems___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default.a
        }
    }, {
        path: '/adminproducts',
        name: 'AdminProducts',
        components: {
            default: __WEBPACK_IMPORTED_MODULE_24__components_AdminProducts___default.a,
            sidebar: __WEBPACK_IMPORTED_MODULE_19__components_AdminSidebar___default.a
        }
    }, {
        path: "*",
        name: '404',
        component: __WEBPACK_IMPORTED_MODULE_25__components_PageNotFound___default.a
    }]
}));

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(163),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {

      //route
      routeEnabled: true,

      //user
      user: {
        id: '',
        name: '',
        email: ''
      },
      sessionSet: false,
      parentCheck: false,

      //cart
      cart: 0,
      items: [],
      itemcodes: [],
      alreadyAdded: false
    };
  },

  methods: {

    logout: function logout() {
      var self = this;
      $.ajax({
        url: 'static/php/logout.php',
        success: function success(data) {
          if (data == true) {
            self.user = {};
            self.sessionSet = false;
            self.$router.push({ path: '/' });
            /*
            console.log(self.user);
            console.log(self.sessionSet);
            */
          } else {
            alert('something went wrong');
          }
        }
      });
    },

    endtransaction: function endtransaction() {
      this.cart = 0;
      this.items = [];
      this.itemcodes = [];
      console.log('cart is empty');
    },

    dadCheck: function dadCheck(bool) {
      this.parentCheck = bool;
    },

    //hahahaha
    check: function check(item) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].code === item.code) {
          return true;
          break;
        }
      }
      return false;
    },

    add: function add(item) {
      if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object') {
        if (this.check(item)) {
          this.alreadyAdded = true;
        } else {
          this.alreadyAdded = false;
          this.cart++;
          this.items.push(item);
          this.itemcodes.push(item.code);
          /*
          console.log(this.items);
          console.log(this.itemcodes);
          */
        }
      }
    },

    removeitem: function removeitem(itemcode) {
      var items = this.items;
      for (var i = 0; i < this.items.length; i++) {
        if (items[i].code === itemcode) {
          this.cart--;
          items.splice(i, 1);
          this.itemcodes.splice(this.itemcodes.indexOf(itemcode), 1);
          break;
        }
      }
    }

  },
  created: function created() {
    var self = this;

    //GET user session
    $.ajax({
      url: 'static/php/check_user_session.php',
      success: function success(data) {
        data = JSON.parse(data);
        if (data.constructor === Array) {
          if (data.length < 1) {
            //session not set
          } else {
            //session set
            self.sessionSet = true;
            self.user = data[0];
          }
        }
      }
    });

    //GET cart session
    $.ajax({
      url: 'static/php/check_cart_session.php',
      success: function success(data) {
        //alert(data);

        data = JSON.parse(data);
        if (data.constructor === Array) {
          var count = data.length;
          if (count < 1) {
            console.log('cart is empty');
          } else {
            self.cart = count;
            self.items = data;
            for (var i = 0; i < count; i++) {
              self.itemcodes.push(data[i].code);
            }
            /*
            console.log(self.cart);
            console.log(self.items);
            console.log(self.itemcodes);
            */
          }
        }
      }
    });
  },
  mounted: function mounted() {
    if (this.$route.name.match(/^(supplier|admin|user|404)/i) || this.$route.name.match(/Products/)) {
      this.routeEnabled = false;
    } else {
      this.routeEnabled = true;
    }
    window.scrollTo(0, 0);
  },

  watch: {
    '$route': function $route(to, from) {
      if (this.$route.name.match(/^(supplier|admin|user|404)/i) || this.$route.name.match(/Products/)) {
        this.routeEnabled = false;
      } else {
        this.routeEnabled = true;
      }
      window.scrollTo(0, 0);
    },


    //Check once
    parentCheck: function parentCheck(newval) {
      if (newval === true) {
        var self = this;

        //GET user session
        $.ajax({
          url: 'static/php/check_user_session.php',
          success: function success(data) {
            data = JSON.parse(data);
            if (data.constructor === Array) {
              if (data.length < 1) {
                //session not set
              } else {
                //session set
                self.sessionSet = true;
                self.user = data[0];
              }
            }
          }
        });

        this.parentCheck = false;
      }
    },

    //Watch: cart, items, itemcodes

    itemcodes: function itemcodes(newval) {
      var self = this;
      $.ajax({
        url: 'static/php/check_cart_session.php',
        type: 'POST',
        data: { itemcodes: newval }
      });
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			bps: [{
				img: '1.jpg'
			}, {
				img: '2.jpg'
			}, {
				img: '3.jpg'
			}, {
				img: '4.jpg'
			}, {
				img: '5.jpg'
			}, {
				img: '6.jpg'
			}, {
				img: '7.jpg'
			}, {
				img: '8.jpg'
			}, {
				img: '9.jpg'
			}, {
				img: '10.jpg'
			}, {
				img: '11.jpg'
			}, {
				img: '12.jpg'
			}]
		};
	},

	methods: {
		AboutResponsive: function AboutResponsive(self) {
			var bp = $('.bp');
			var bpParent = bp[0].parentNode;
			$(bpParent).children(".clearboth").remove();
			var ww = $(window).outerWidth();

			if (ww >= 992) {
				for (var i = 0; i < bp.length; i++) {
					if (i % 4 === 0) {
						var node = document.createElement("div");
						node.setAttribute("class", "clearboth");
						bpParent.insertBefore(node, bp[i]);
					}
				}
			} else if (ww >= 768 && ww < 992) {
				for (var i = 0; i < bp.length; i++) {
					if (i % 3 === 0) {
						var node = document.createElement("div");
						node.setAttribute("class", "clearboth");
						bpParent.insertBefore(node, bp[i]);
					}
				}
			} else if (ww < 768) {
				for (var i = 0; i < bp.length; i++) {
					if (i % 2 === 0) {
						var node = document.createElement("div");
						node.setAttribute("class", "clearboth");
						bpParent.insertBefore(node, bp[i]);
					}
				}
			}
		}
	},
	mounted: function mounted() {
		var self = this;
		// relativeTo
		relativeTo('nav', this.$el);

		this.AboutResponsive(self);
		$(window).on("resize.About", function (e) {
			self.AboutResponsive(self);
		});
	},
	destroyed: function destroyed() {
		$(window).off("resize.About");
	}
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {};
	},
	created: function created() {
		if (this.issessionset === true) {
			this.$router.push({ path: '/user' });
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === true) {
				this.$router.push({ path: '/user' });
			}
		}
	}
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			token: ''
		};
	},

	methods: {
		addProduct: function addProduct(event) {
			var self = this;
			var product_name = $(event.target).find('#product_name').val();
			var price = $(event.target).find('#price').val();
			var category = $(event.target).find('#category').val();
			var material = $(event.target).find('#material').val();
			var stock = $(event.target).find('#stock').val();
			var color = $(event.target).find('#color').val();
			var led = $(event.target).find('#led').val();
			var image = $(event.target).find('#image')[0].files[0];
			//this is the token
			var token = $(event.target).find('#token').val();
			//var product_image = $(event.target).find('input[name="product_image"]')[0].files[0];

			var formData = new FormData();

			formData.append('product_name', product_name);
			formData.append('price', price);
			formData.append('category', category);
			formData.append('material', material);
			formData.append('stock', stock);
			formData.append('color', color);
			formData.append('led', led);
			formData.append('image', image);
			//this is the token
			formData.append('token', token);
			//formData.append('product_image', product_image);


			$.ajax({
				url: 'static/php/adminupload.php',
				type: 'POST',
				data: formData,
				cache: false,
				contentType: false,
				processData: false,
				success: function success(data) {
					console.log(data);
					alert(data);
				}
			});
		}
	},
	created: function created() {
		var self = this;
		$.ajax({
			url: 'static/php/gettoken.php',
			success: function success(data) {
				if (typeof data === "string") {
					self.token = data;
				}
			}
		});
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//CHECK SESSION AGAIN IF POSSIBLE
/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {
			token: ''
		};
	},

	methods: {
		buyerRegister: function buyerRegister(event) {
			var self = this;
			var data = $(event.target).serialize();
			$.ajax({
				url: 'static/php/userregistration.php',
				type: 'post',
				data: data,
				success: function success(data) {
					if (data === 'ok') {
						self.$router.push({ path: '/login' });
					} else {
						$('#message').html(data);
						$.ajax({
							url: 'static/php/gettoken.php',
							success: function success(data) {
								if (typeof data === "string") {
									self.token = data;
								}
							}
						});
					}
				}
			});
		}
	},
	created: function created() {
		var self = this;
		if (this.issessionset === true) {
			this.$router.push({ path: '/user' });
		} else {
			$.ajax({
				url: 'static/php/gettoken.php',
				success: function success(data) {
					if (typeof data === "string") {
						self.token = data;
					}
				}
			});
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === true) {
				this.$router.push({ path: '/user' });
			}
		}
	}
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderNotification_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OrderNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartNotification_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MembershipNotification_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MembershipNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MembershipNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Item_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//this is notification b

//notificationS


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['items', 'issessionset'],
	data: function data() {
		return {
			token: '',
			total: 0,
			price: 0,
			itemsinfo: [],
			show: false,
			notification: false,
			notificationb: false,
			//this is experimental
			nbc: '#EBD911',
			nbm: 'Item Removed',
			//this is experimental

			notificationS: false
			//don't turn off the trigger 
			//force user to create an account;
			//so that we can keep track of their purchases
		};
	},

	methods: {

		formatMoney: formatMoney,

		gettoken: function gettoken() {
			//this is experimental 

			//do not try this at home
		},

		endtransaction: function endtransaction() {
			this.notification = false;
			this.$emit('endtransaction');
		},

		additem: function additem(iteminfo) {
			this.itemsinfo.push(iteminfo);
			this.total++;
			this.price += parseFloat(iteminfo.price);
		},

		incrementTotal: function incrementTotal(iteminfo) {
			this.total++;
			this.price += parseFloat(iteminfo.price);
			for (var i = 0; i < this.itemsinfo.length; i++) {
				if (this.itemsinfo[i].code === iteminfo.code) {
					this.itemsinfo[i].quantity = iteminfo.quantity;
					this.itemsinfo[i].total = iteminfo.total;
					break;
				}
			}
		},
		decrementTotal: function decrementTotal(iteminfo) {
			this.total--;
			this.price -= parseFloat(iteminfo.price);
			for (var i = 0; i < this.itemsinfo.length; i++) {
				if (this.itemsinfo[i].code === iteminfo.code) {
					this.itemsinfo[i].quantity = iteminfo.quantity;
					this.itemsinfo[i].total = iteminfo.total;
					break;
				}
			}
		},
		removeitem: function removeitem(iteminfo) {
			var self = this;
			for (var i = 0; i < this.itemsinfo.length; i++) {
				if (this.itemsinfo[i].code === iteminfo.code) {
					this.total -= iteminfo.quantity;
					this.price -= iteminfo.total;
					this.itemsinfo.splice(i, 1);
					this.$emit('removeitem', iteminfo.code);
					break;
				}
			}
			this.notificationb = true;
			setTimeout(function () {
				self.notificationb = false;
			}, 3000);
		},
		placeOrder: function placeOrder() {
			var self = this;

			var ordersinfo = [];
			ordersinfo.push(this.itemsinfo.length, this.price); // 2, 500,000


			$.ajax({
				url: 'static/php/orders.php',
				type: 'post',
				data: {
					ordersinfo: ordersinfo,
					itemsinfo: self.itemsinfo,
					token: self.token
				},
				success: function success(data) {
					//data = string '1'
					if (data == true) {

						self.notification = true;
					} else if (data === 'session') {

						//alert('You need to be logged in or registered to continue with your purchase');
						self.notificationS = true;
					} else if (data === 'token') {
						//fix this later 
						$.ajax({
							url: 'static/php/gettoken.php',
							success: function success(data) {
								if (typeof data === "string") {
									self.token = data;
								}
							}
						});

						//fix this later
						//use csrf on when posting data RULE 34

						alert('token mismatch');
					} else {
						$.ajax({
							url: 'static/php/gettoken.php',
							success: function success(data) {
								if (typeof data === "string") {
									self.token = data;
								}
							}
						});

						alert('Oops something went wrong. try refreshing your browser');
					}
				}
			});
		}

	},
	created: function created() {
		//this is the cart right?
		//users must have session to access this.
		var self = this;
		//temporary move the code;
		//display items?
		if (this.items.constructor === Array) {
			if (this.items.length < 1) {
				this.show = false;
			} else {
				this.show = true;
			}
		}
		//display items?
		if (this.issessionset === true) {
			//temporary move the code;
			//assumption issessionset is true on create
			$.ajax({
				url: 'static/php/gettoken.php',
				success: function success(data) {
					if (typeof data === "string") {
						self.token = data;
					}
				}
			});
			//assumption issessionset is true on create
		} else {
				//this.$router.push({path: '/login'});
			}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval !== true) {
				//this.$router.push({path: '/login'});
			}
		},
		items: function items(newval) {
			if (this.items.length < 1) {
				this.show = false;
			} else {
				this.show = true;
			}
		}
	},
	components: {
		'item': __WEBPACK_IMPORTED_MODULE_3__Item_vue___default.a,
		'notification': __WEBPACK_IMPORTED_MODULE_0__OrderNotification_vue___default.a,
		'notification-b': __WEBPACK_IMPORTED_MODULE_1__CartNotification_vue___default.a,
		'notification-s': __WEBPACK_IMPORTED_MODULE_2__MembershipNotification_vue___default.a
	}
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['nbc', 'nbm'],
	mounted: function mounted() {
		this.$el.getElementsByTagName('span')[0].style.background = this.nbc;
		this.$el.getElementsByTagName('p')[0].textContent = this.nbm;
	}
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			date: new Date().getFullYear().toString()
		};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {
			show: true,
			disabled: true
		};
	},
	created: function created() {
		if (this.issessionset === true) {
			this.show = false;
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === true) {
				this.show = false;
			} else {
				this.show = true;
			}
		}
	}
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset', 'user', 'cart'],
	data: function data() {
		return {
			disabled: true
		};
	},

	methods: {
		mobileMenu: function mobileMenu(event) {
			$("body").toggleClass("overflow-toggle");
			$("#nav-bar").slideToggle(490);
		},

		logout: function logout(event) {
			this.$emit('logout');
		},

		//DOM responsive
		HeaderResponsive: function HeaderResponsive(self) {
			var ww = $(window).outerWidth();
			if (ww < 992) {
				$("#nav-bar > li > a").off();
				$("#nav-bar > li > a").click(function () {
					$("body").toggleClass("overflow-toggle");
					$("#nav-bar").slideToggle(490);
				});
			} else {
				$("#nav-bar > li > a").off();
			}
		}
	},
	mounted: function mounted() {
		var self = this;

		this.HeaderResponsive(self);
		$(window).resize(function () {
			self.HeaderResponsive(self);
		});
	}
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			infoItems: [{
				img: 'e.svg',
				header: 'Trusted Product',
				text: 'Established in 1987, Mutual Success Lighting Fixture Inc., has maintained its position as a quality lighting provider in the industry.'
			}, {
				img: 'e.svg',
				header: 'Quality-Tested',
				text: 'With over twenty-five (25) years of continuous innovation, customer service and excellence, the company relatively expanded, numerically evident by the availability of product lines in more than 250 major depots and DIY\'s nationwide.'
			}, {
				img: 'e.svg',
				header: 'Light-Wise',
				text: 'Mutual Success Lighting Fixture Inc. offers all types of lighting requirements. From ambient lighting to general lighting, from accent and task lighting to outdoor and industrial lighting; all of which have the objective of providing lighting needs and satisfaction essential to daily living.'
			}],

			fproducts: [],

			bannerSlides: [{
				img: 'a.jpeg',
				header: 'Apollo Lightings',
				text: 'Your Light Partner',
				button: 'View Products',
				href: '/products'
			}],

			disabled: true
		};
	},

	methods: {
		formatMoney: formatMoney,
		bbl: function bbl(link) {
			this.$router.push({ path: link });
		}
	},
	created: function created() {
		var self = this;
		$.ajax({
			url: 'static/php/featuredproducts.php',
			success: function success(data) {
				data = JSON.parse(data);
				self.fproducts = data;
			}
		});
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);

		//Assign Background Images
		$('.banner-slide').each(function () {
			$(this).css({
				"background": 'url("static/images/' + $(this).attr('img') + '") no-repeat center center',
				"background-size": "cover"
			});
		});

		function HomeResponsive() {
			$('.banner-slide').css({
				"height": $(window).outerHeight() - $('#nav').outerHeight() + "px"
			});

			$('.slide-info').each(function (index) {
				$(this).css({
					"top": "calc(50% - " + $(this).outerHeight() / 2 + "px)",
					"left": "calc(50% - " + $(this).outerWidth() / 2 + "px)"
				});
			});
		}

		HomeResponsive();
		$(window).on("resize.Home", HomeResponsive);
	},
	destroyed: function destroyed() {
		$(window).off("resize.Home");
	}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['item'],
	data: function data() {
		return {
			counter: 1
		};
	},

	computed: {
		totalPrice: function totalPrice() {
			return parseFloat(this.item.price) * this.counter;
		},
		iteminfo: function iteminfo() {
			return {
				code: this.item.code,
				price: this.item.price,
				quantity: this.counter,
				total: this.totalPrice
			};
		}
	},
	methods: {

		formatMoney: formatMoney,

		addq: function addq(event) {
			this.counter++;
			this.$emit('increment', this.iteminfo);
		},
		minq: function minq(event) {
			if (this.counter <= 1) {} else {
				this.counter--;
				this.$emit('decrement', this.iteminfo);
			}
		},
		removeitem: function removeitem(event) {
			this.$emit('removeitem', this.iteminfo);
		}
	},
	created: function created() {
		this.$emit('additem', this.iteminfo);
	}
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			locationlist: []
		};
	},

	methods: {
		search: function search(event) {
			var self = this;
			var search = $(event.target).val().trim();
			// console.log(search);
			$.ajax({
				url: 'static/php/searchlocation.php',
				data: { search: search },
				type: 'POST',
				success: function success(data) {
					if (data === '' || JSON.parse(data).length === 0) {
						self.locationlist = [];
					} else {
						data = JSON.parse(data);
						self.locationlist = data;
					}
				}
			});
		},

		center: function center(event) {
			var value = event.target.innerHTML;
			var lat = parseFloat(event.target.getAttribute('lat'));
			var lng = parseFloat(event.target.getAttribute('lng'));
			$('#search').val(value);
			map.panTo({
				lat: lat,
				lng: lng
			});
			$('#locationlist').html('');
		}
	},
	created: function created() {},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
		initMap();
	}
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {
			token: ''
		};
	},

	methods: {
		login: function login(event) {
			var self = this;
			var data = $(event.target).serialize();

			$.ajax({
				url: 'static/php/login.php',
				type: 'post',
				data: data,
				success: function success(data) {
					if (data == 1) {
						self.$emit('session', true);
						self.$router.push({ path: '/user' });
					} else {
						$('#message').html(data);
						$.ajax({
							url: 'static/php/gettoken.php',
							success: function success(data) {
								if (typeof data === "string") {
									self.token = data;
								}
							}
						});
					}
				}
			});
		}
	},
	created: function created() {
		var self = this;
		if (this.issessionset === true) {
			this.$router.push({ path: '/user' });
		} else {
			$.ajax({
				url: 'static/php/gettoken.php',
				success: function success(data) {
					if (typeof data === "string") {
						self.token = data;
					}
				}
			});
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === true) {
				this.$router.push({ path: '/user' });
			}
		}
		//rename user - userreceipts
	} });

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//NO current data
/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		endtransaction: function endtransaction() {
			this.$emit('endtransaction');
		}
	}
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//NO current data
/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['orderinfo', 'ordercode'],
	methods: {
		formatMoney: formatMoney,

		exitReceipt: function exitReceipt(event) {
			this.$emit('exitReceipt');
		}
	}
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
		this.$el.style.height = 'calc(100% - ' + id('nav').offsetHeight + 'px)';
	}
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			product_info: {},

			disabled: true
		};
	},

	methods: {
		formatMoney: formatMoney
	},
	created: function created() {

		var self = this;
		var params = this.$route.params;

		$.ajax({
			url: 'static/php/products.php',
			type: 'post',
			data: params,
			success: function success(data) {
				data = JSON.parse(data);
				self.product_info = data;
			}
		});
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		'$route': function $route(to, from) {
			var self = this;
			var route = this.$route.fullPath;
			var params = this.$route.params;
			// console.log(params);
		}
	}
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CartNotification_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CartNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CartNotification_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['alreadyAdded'],
	data: function data() {
		return {

			notification: false,
			nbc: '#4DCC2F',
			nbm: '',

			products: [],
			filters: {},
			showadvs: false,

			showr: false,

			disabled: true
		};
	},

	methods: {

		formatMoney: formatMoney,

		advs: function advs(event) {
			this.showadvs = !this.showadvs;
		},
		advFilters: function advFilters(filter, event) {
			var obj = {};
			obj[filter] = event.target.value;
			this.$router.push({ path: this.$route.fullPath, query: obj });
		},
		filterId: function filterId(filtervalue) {
			return filtervalue.split("|")[1].trim();
		},
		filterName: function filterName(filtervalue) {
			return filtervalue.split("|")[0].trim();
		},

		maxprice: function maxprice(event) {
			var value = event.target.value;
			this.$router.push({ path: this.$route.fullPath, query: { maxprice: value } });
		},

		category: function category(value, event) {

			if (!$(event.target).hasClass("active-category")) {
				$('.category').removeClass("active-category");
				$(event.target).addClass("active-category");
			} else {
				// console.log('class exists fam!');
			}

			this.$router.push({ path: this.$route.fullPath, query: { category: value } });
		},

		addToCart: function addToCart(product, event) {

			var self = this;
			this.$emit('addtocart', product);
			this.notification = true;
			setTimeout(function () {
				self.notification = false;
			}, 3000);
		},

		//DOM responsive functions go here
		ProductsResponsive: function ProductsResponsive(self) {
			var ww = $(window).outerWidth();
			if (ww < 992) {
				self.showr = true;
				$('#products').css("margin-left", "0px");
			} else {
				self.showr = false;
				setTimeout(function () {
					$('#product-filters').css({
						"top": $('#nav').outerHeight() + "px",
						"height": "calc(100% - " + $('#nav').outerHeight() + "px)"
					});
					$('#products').css({
						"margin-left": $('#product-filters').outerWidth() + "px"
					});
				}, 100);
			}
		}
	},
	created: function created() {
		var self = this;

		//GET FILTERS
		$.ajax({
			url: 'static/php/allfilters.php',
			success: function success(data) {
				data = JSON.parse(data);
				self.filters = data;
			}
		});

		//GET products
		$.ajax({
			url: 'static/php/products.php',
			success: function success(data) {
				self.products = JSON.parse(data);
			}
		});

		//GET message
		if (this.alreadyAdded === false) {
			this.nbm = 'Added to Cart';
		} else if (this.alreadyAdded === true) {
			this.nbm = 'Item already in cart';
		}
	},
	mounted: function mounted() {
		var self = this;
		relativeTo('nav', this.$el);

		this.ProductsResponsive(self);
		$(window).on("resize.Products", function () {
			self.ProductsResponsive(self);
		});
	},
	destroyed: function destroyed() {
		$(window).off("resize.Products");
	},

	watch: {
		'$route': function $route(to, from) {
			var self = this;
			var query = this.$route.query;
			// console.log(query);

			$.ajax({
				url: 'static/php/products.php',
				data: query,
				success: function success(data) {
					self.products = JSON.parse(data);
				}
			});
		},


		alreadyAdded: function alreadyAdded(newval) {
			if (newval === false) {
				this.nbm = 'Added to Cart';
			} else if (newval === true) {
				this.nbm = 'Item already in cart';
			}
		}
	},
	components: {
		'notification': __WEBPACK_IMPORTED_MODULE_0__CartNotification_vue___default.a
	}
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {};
	},

	methods: {
		supplierRegister: function supplierRegister(event) {
			var data = $(event.target).serialize();
			//Supplier register
		}
	},
	created: function created() {
		if (this.issessionset === true) {
			this.$router.push({ path: '/user' });
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === true) {
				this.$router.push({ path: '/user' });
			}
		}
	}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderReceipt_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrderReceipt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__OrderReceipt_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {
			showr: false,
			ordersinfo: [],

			showReceipt: false,
			orderinfo: [],
			currentOrderCode: ''
		};
	},

	methods: {

		formatMoney: formatMoney,

		viewreceipt: function viewreceipt(ordercode) {
			var self = this;
			$.ajax({
				url: 'static/php/orders.php',
				data: { ordercode: ordercode },
				success: function success(data) {
					data = JSON.parse(data);
					self.orderinfo = data;
					self.currentOrderCode = ordercode;
					self.showReceipt = true;
				}
			});
		},
		exitReceipt: function exitReceipt(event) {
			this.showReceipt = false;
		}
	},
	watch: {
		issessionset: function issessionset(newval) {
			var self = this;
			if (newval === true) {
				$.ajax({
					url: 'static/php/orders.php',
					success: function success(data) {
						data = JSON.parse(data);
						if (!data.length < 1) {
							self.ordersinfo = data;
							self.showr = true;
						}
					}
				});
			} else {
				this.$router.push({ path: '/login' });
			}
		}
	},
	created: function created() {
		var self = this;
		if (this.issessionset === true) {
			$.ajax({
				url: 'static/php/orders.php',
				success: function success(data) {
					data = JSON.parse(data);
					//additional validation over here 
					if (!data.length < 1) {
						self.ordersinfo = data;
						self.showr = true;
					}
				}
			});
		} else {
			this.$router.push({ path: '/login' });
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	components: {
		'orderreceipt': __WEBPACK_IMPORTED_MODULE_0__OrderReceipt_vue___default.a
	}
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset', 'user'],
	data: function data() {
		return {
			showpw: false,
			showmb: false,
			//multi-request CSRF protection experiment
			changepwtoken: '',
			changembtoken: '',

			notification: false,
			notificationMessage: ''
		};
	},

	methods: {
		ShowChangePW: function ShowChangePW(event) {
			this.GetPWToken();
			this.showpw = true;
		},
		ChangePassword: function ChangePassword(event) {
			var self = this;
			var data = $(event.target).serialize();
			$.ajax({
				url: 'static/php/changepassword.php',
				type: 'POST',
				data: data,
				success: function success(data) {

					console.log(data);
					if (data == true) {
						self.notification = true;
						self.notificationMessage = 'Password Changed';
						setTimeout(function () {
							self.notification = false;
							self.notificationMessage = '';
						}, 3000);
					} else {
						alert(data);
					}
				}
			});
			this.showpw = false;
			this.changepwtoken = '';
		},
		GetPWToken: function GetPWToken() {
			var self = this;
			$.ajax({
				url: 'static/php/gettoken.php',
				success: function success(data) {
					if (typeof data === "string") {
						self.changepwtoken = data;
					}
				}
			});
		},
		ShowChangeMB: function ShowChangeMB(event) {
			this.showmb = true;
		},
		ChangeMobile: function ChangeMobile(event) {
			var self = this;
			var data = $(event.target).serialize();
			$.ajax({
				url: 'static/php/changemobile.php',
				type: 'POST',
				data: data,
				success: function success(data) {
					alert(data);
					self.showmb = false;
					self.changembtoken = '';
					location.reload();
				}
			});
		}
	},
	created: function created() {
		if (this.issessionset === false) {
			this.$router.push({ path: '/login' });
		}
	},
	mounted: function mounted() {
		relativeTo('nav', this.$el);
	},

	watch: {
		issessionset: function issessionset(newval) {
			if (newval === false) {
				this.$router.push({ path: '/login' });
			}
		}
	}
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['issessionset'],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Copyright__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Copyright__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






//these are the defaults




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
  id: 'UA-103145457-1',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
});
//event goes here

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-header', __WEBPACK_IMPORTED_MODULE_4__components_Header___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-footer', __WEBPACK_IMPORTED_MODULE_5__components_Footer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-copyright', __WEBPACK_IMPORTED_MODULE_6__components_Copyright___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }

});

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(166),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(140),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(142),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(146),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(169),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(154),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(155),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(145),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(161),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(151),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(148),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(149),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(160),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(170),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(143),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-a"
  }, [_c('div', [_c('div', [_c('h1', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Purchase Successful!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button-type-e",
    staticStyle: {
      "font-size": "1.17em",
      "width": "100%"
    },
    on: {
      "click": _vm.endtransaction
    }
  }, [_vm._v("Done!")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You may check your receipts "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Here")]), _c('br'), _vm._v("Thank you for choosing Apollo!")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "product-categories"
    }
  }, [(!_vm.showr) ? _c('div', {
    staticClass: "col-md-3",
    attrs: {
      "id": "product-filters"
    }
  }, [_c('h1', [_vm._v("Our Products")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "capitalize category active-category",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.category('', $event)
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.filters.category), function(c) {
    return _c('li', [_c('a', {
      staticClass: "capitalize category",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.category(_vm.filterId(c), $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.filterName(c)))])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "products"
    }
  }, [(_vm.showr) ? _c('h1', [_vm._v("Our Products")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "product-search"
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "text",
      "name": "maxprice",
      "placeholder": "Enter max price"
    },
    on: {
      "change": _vm.maxprice,
      "keyup": _vm.maxprice
    }
  }), _vm._v(" "), (_vm.showr) ? _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('category', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Category")]), _vm._v(" "), _vm._l((_vm.filters.category), function(category) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(category)
      }
    }, [_vm._v(_vm._s(_vm.filterName(category)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('select', {
    attrs: {
      "name": "materials"
    },
    on: {
      "change": function($event) {
        _vm.advFilters('materials', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Material")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.filters.materials), function(material) {
    return _c('option', {
      staticClass: "capitalize",
      domProps: {
        "value": _vm.filterId(material)
      }
    }, [_vm._v(_vm._s(_vm.filterName(material)))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-j",
    class: {
      showadvs: _vm.showadvs
    },
    on: {
      "click": _vm.advs
    }
  }, [_vm._v("Advanced Search")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showadvs) ? _c('div', {
    attrs: {
      "id": "advanced-product-search"
    }
  }, [_c('div', [_c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('design', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Design")]), _vm._v(" "), _vm._l((_vm.filters.design), function(design) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(design)
      }
    }, [_vm._v(_vm._s(_vm.filterName(design)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('finish', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Finish")]), _vm._v(" "), _vm._l((_vm.filters.finish), function(finish) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(finish)
      }
    }, [_vm._v(_vm._s(_vm.filterName(finish)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('socket', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Socket Type")]), _vm._v(" "), _vm._l((_vm.filters.sockettype), function(sockettype) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(sockettype)
      }
    }, [_vm._v(_vm._s(_vm.filterName(sockettype)))])
  })], 2), _vm._v(" "), _c('select', {
    on: {
      "change": function($event) {
        _vm.advFilters('forplace', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Place")]), _vm._v(" "), _vm._l((_vm.filters.place), function(place) {
    return _c('option', {
      domProps: {
        "value": _vm.filterId(place)
      }
    }, [_vm._v(_vm._s(_vm.filterName(place)))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.code,
      staticClass: "product col-sm-6 col-md-4",
      attrs: {
        "to": '/products/product/' + product.code,
        "id": product.code
      }
    }, [_c('div', [_c('img', {
      attrs: {
        "src": 'static/images/products/' + product.code + '.jpg',
        "alt": product.name
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_vm._v("Php " + _vm._s(_vm.formatMoney(product.price)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(product.categoryName))]), _vm._v(" "), (!_vm.disabled) ? _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.addToCart(product, $event)
        }
      }
    }, [_vm._v("Add to Cart")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.products.length) ? _c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "4em 0"
    }
  }, [_vm._v("No Results Found")]) : _vm._e()], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('notification', {
    attrs: {
      "nbm": _vm.nbm,
      "nbc": _vm.nbc
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "admin-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((14), function(n) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v("Phelix Systems")]), _vm._v(" "), _c('td', [_vm._v("6SGHA14")]), _vm._v(" "), _c('td', [_vm._v("140.00")]), _vm._v(" "), _c('td', [_vm._v("PHP")]), _vm._v(" "), _vm._m(3, true)])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Supplier Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Product"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Suppliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Price")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Product Code")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Currency")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/j.jpeg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-options"
  }, [_c('button', [_vm._v("Edit Item")]), _vm._v(" "), _c('button', [_vm._v("Delete Item")])])
}]}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item-admin"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v("View Product")])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("New Proposals")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Supplier")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Supplier: "), _c('strong', [_vm._v("Phelix Systems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")]), _vm._v(" "), _c('small', [_vm._v("FOB")])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "admin-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((14), function(n) {
    return _c('tr', [_c('td', [_vm._v("Phelix Systems")]), _vm._v(" "), _c('td', [_vm._v("Phelix@email.com")]), _vm._v(" "), _c('td', [_vm._v("09986573838")]), _vm._v(" "), _c('td', [_vm._v("Phelix Max")]), _vm._v(" "), _c('td', [_vm._v("AST")]), _vm._v(" "), _vm._m(2, true)])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Suppliers")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Supplier"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("PO Format")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Contact #")]), _vm._v(" "), _c('th', [_vm._v("Contact Person")]), _vm._v(" "), _c('th', [_vm._v("PO Format")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-options"
  }, [_c('button', [_vm._v("Edit Account")]), _vm._v(" "), _c('button', [_vm._v("Delete Account")])])
}]}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suppliersidebar"
    }
  }, [_c('ul', [(_vm.issessionset) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("My Purchases")])], 1) : _vm._e(), _vm._v(" "), (_vm.issessionset) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/useraccount"
    }
  }, [_vm._v("Account Information")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("Cart")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-m"
  }, [_c('div', [_c('div', [_c('h1', [_vm._v("Hi There!")]), _vm._v(" "), _c('p', [_vm._v("Please login or register an account to continue with your purchase.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "button-type-h",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    staticClass: "button-type-h",
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "to": "/registration/buyer"
    }
  }, [_vm._v("Register")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagenotfound"
  }, [_c('div', [_c('div', [_c('h1', [_vm._v("The page you requested is not available!")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-i",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "banner"
    }
  }, _vm._l((_vm.bannerSlides), function(bannerSlide, index) {
    return _c('div', {
      staticClass: "banner-slide",
      attrs: {
        "img": bannerSlide.img
      }
    }, [_c('div', {
      staticClass: "slide-info"
    }, [_c('h1', [_vm._v(_vm._s(bannerSlide.header))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bannerSlide.text))]), _vm._v(" "), (bannerSlide.button != null) ? _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.bbl(bannerSlide.href)
        }
      }
    }, [_vm._v(_vm._s(bannerSlide.button))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "info-container"
  }, _vm._l((_vm.infoItems), function(infoItem) {
    return _c('div', {
      staticClass: "info-item col-md-4"
    }, [_c('div', {
      staticClass: "info-icon"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/' + infoItem.img
      }
    })]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(infoItem.header))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(infoItem.text))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "featured-products"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fproducts), function(fproduct) {
    return _c('router-link', {
      key: fproduct.code,
      staticClass: "fproduct col-xs-12 col-sm-6 col-md-3",
      attrs: {
        "to": '/products/product/' + fproduct.code
      }
    }, [_c('img', {
      attrs: {
        "src": 'static/images/products/' + fproduct.code + '.jpg',
        "alt": fproduct.name
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(fproduct.name))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_vm._v("Php " + _vm._s(_vm.formatMoney(fproduct.price)))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(fproduct.categoryName))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearboth"
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-section",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("View All Products")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "link-section"
  }, [_c('h1', [_vm._v("With over 250 branches across the Philippines")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/locations"
    }
  }, [_vm._v("View Locations")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fp-header"
  }, [_c('h1', [_vm._v("Our Featured Products")])])
}]}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('h1', [_vm._v("Product Information")]), _vm._v(" "), _c('p', [_vm._v("Fill up all necessary information")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "proposeitem",
      "method": "post",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addProduct($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "token",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "product_name"
    }
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "product_name",
      "id": "product_name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Price (Php)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "price",
      "id": "price"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stock"
    }
  }, [_vm._v("No. of Available Stock")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "stock",
      "id": "stock"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "color",
      "id": "color"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "category",
      "id": "category"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("select category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "light"
    }
  }, [_vm._v("light")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dark"
    }
  }, [_vm._v("dark")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "led"
    }
  }, [_vm._v("Led Capable")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "led",
      "id": "led"
    }
  }, [_c('option', {
    attrs: {
      "value": "YES",
      "selected": ""
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO"
    }
  }, [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "material"
    }
  }, [_vm._v("Material")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "material",
      "id": "material"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select Material")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wood"
    }
  }, [_vm._v("wood")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "glass"
    }
  }, [_vm._v("glass")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "concrete"
    }
  }, [_vm._v("concrete")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "image"
    }
  }, [_vm._v("Product Image")]), _vm._v(" "), _c('input', {
    staticStyle: {},
    attrs: {
      "type": "file",
      "name": "image",
      "id": "image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Upload Product")])])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding",
    attrs: {
      "id": "myproduct"
    }
  }, [_c('p', {
    staticClass: "header-type-e"
  }, [_vm._v("Product: 6SGHA14")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "ex1"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": "static/images/j.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Info")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Description")])]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Price")]), _vm._v(" Php 140.00")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Specs")]), _vm._v(" "), _c('ul', {
    staticClass: "product-specs"
  }, [_c('li', [_c('strong', [_vm._v("Box Dimension (cm)")]), _vm._v(" 7 x 7 x 7")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item Dimension (cm)")]), _vm._v(" 7 x 7 x 7")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Design")]), _vm._v(" Classic")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Materials")]), _vm._v(" Acrylic")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Socket Type")]), _vm._v(" E12")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Finish")]), _vm._v(" Antique Brass")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Category")]), _vm._v(" Bulbs")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Place")]), _vm._v(" Aisle")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Ceiling")]), _vm._v(" High Ceiling")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("I/O")]), _vm._v(" Indoor")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("LED")]), _vm._v(" LED Capable")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "padding-bottom": "40px"
    }
  })])])
}]}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Product Information")]), _vm._v(" "), _c('p', [_vm._v("Fill up all necessary information")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "proposeitem",
      "method": "POST",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "code",
      "id": "code"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "description",
      "id": "description"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "no_of_sockets"
    }
  }, [_vm._v("No. of Sockets")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "no_of_sockets",
      "id": "no_of_sockets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "package_dimensions"
    }
  }, [_vm._v("Package Dimension")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "package_dimensions",
      "id": "package_dimensions",
      "placeholder": "L x W x H"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "item_dimensions"
    }
  }, [_vm._v("Item Dimension")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "item_dimensions",
      "id": "item_dimensions",
      "placeholder": "L x W x H"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "min_order"
    }
  }, [_vm._v("Minimum order quantity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "min_order",
      "id": "min_order"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "price",
      "id": "price"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pricing"
    }
  }, [_vm._v("Pricing")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "pricing",
      "id": "pricing"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("FOB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("CIF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("CNF")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "currency"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "currency",
      "id": "currency"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Php")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Usd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("jpy")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Product Specifications")]), _vm._v(" "), _c('p', [_vm._v("Check all items that apply")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Design")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check1"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check1",
      "value": "val1"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Classic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check2"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check2",
      "value": "val2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Contemporary")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check3"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check3",
      "value": "val3"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Modern")]), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Materials")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check4"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check4",
      "value": "val4"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Acrylic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check5"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check5",
      "value": "val5"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Crystal")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check6"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check6",
      "value": "val6"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Plastic")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check7"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check7",
      "value": "val7"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Aluminum")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check8"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check8",
      "value": "val8"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Glass")]), _c('div')]), _vm._v(" "), _c('label', {
    staticClass: "spec col-md-4 col-xs-12",
    attrs: {
      "for": "check9"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "check[]",
      "id": "check9",
      "value": "val9"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Wood")]), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Add other items here later")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e"
  }, [_vm._v("Propose Item")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-bottom": "40px"
    }
  })])])])
}]}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [(!_vm.showr) ? _c('div', {
    staticClass: "text-center pcsp"
  }, [_c('h1', [_vm._v("You have not made any purchases yet")]), _vm._v(" "), _c('p', [_vm._v("this page displays all receipts click cart to view cart")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-h",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Start Shopping!")])], 1) : _vm._e(), _vm._v(" "), (_vm.showr) ? _c('div', {
    staticClass: "pcsp"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("My Receipts")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.ordersinfo), function(order) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(order.order_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_date.split(" ").shift()))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Php " + _vm._s(_vm.formatMoney(order.price)))]), _vm._v(" "), _c('td', {
      staticClass: "admin-table-row-options"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.viewreceipt(order.order_no)
        }
      }
    }, [_vm._v("View")])])])
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showReceipt) ? _c('orderreceipt', {
    attrs: {
      "orderinfo": _vm.orderinfo,
      "ordercode": _vm.currentOrderCode
    },
    on: {
      "exitReceipt": _vm.exitReceipt
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Receipts")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Order Code:")]), _vm._v(" "), _c('th', [_vm._v("Date:")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price:")]), _vm._v(" "), _c('th', [_vm._v("Receipt:")])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "url('static/images/b.jpeg') no-repeat center center",
      "background-size": "cover"
    },
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "register"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.supplierRegister($event)
      }
    }
  }, [_c('h3', [_vm._v("Account Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Full name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username",
      "placeholder": "username"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "email"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "id": "password_confirmation",
      "placeholder": "Confirm Password"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Supplier Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company_name"
    }
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "company_name",
      "id": "company_name",
      "placeholder": "Company name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company_address"
    }
  }, [_vm._v("Company Address")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "company_address",
      "id": "company_address",
      "placeholder": "Company address"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "contact_number"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "contact_number",
      "id": "contact_number",
      "placeholder": "Contact number"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "value"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Register")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Supplier Registration")]), _vm._v(" "), _c('p', [_vm._v("this template currently applies for suppliers")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Post your products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications and feedbacks about your products")])])])
}]}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 50px"
    }
  }, [(!_vm.show) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h1', [_vm._v("You currently have no items in cart")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "1.17em",
      "border": "1px solid transparent",
      "background": "#4DCC2F",
      "padding": "0.75em 1em",
      "border-radius": "1.5em",
      "color": "#fff"
    },
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Start Shopping!")])], 1) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("My Cart")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticStyle: {
      "display": "block",
      "overflow": "hidden",
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_vm._v("Options")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return (_vm.show) ? _c('item', {
      key: item.code,
      attrs: {
        "item": item
      },
      on: {
        "increment": function($event) {
          _vm.incrementTotal($event)
        },
        "decrement": function($event) {
          _vm.decrementTotal($event)
        },
        "additem": function($event) {
          _vm.additem($event)
        },
        "removeitem": function($event) {
          _vm.removeitem($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('strong', [_vm._v("Total Items")]), _vm._v(" " + _vm._s(_vm.total) + " \n\t\t\t"), _c('strong', [_vm._v("Total Price")]), _vm._v(" Php " + _vm._s(_vm.formatMoney(_vm.price)) + " \n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding": "0px 15px",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "button-type-e",
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("Place Order")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('notification', {
    on: {
      "endtransaction": _vm.endtransaction
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notificationb) ? _c('notification-b', {
    attrs: {
      "nbc": _vm.nbc,
      "nbm": _vm.nbm
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notificationS) ? _c('notification-s') : _vm._e()], 1)], 2)])
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "body"
    }
  }, [_c('app-header', {
    attrs: {
      "issessionset": _vm.sessionSet,
      "user": _vm.user,
      "cart": _vm.cart,
      "items": _vm.items
    },
    on: {
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "sidebar",
      "issessionset": _vm.sessionSet
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "issessionset": _vm.sessionSet,
      "items": _vm.items,
      "user": _vm.user,
      "alreadyAdded": _vm.alreadyAdded
    },
    on: {
      "session": function($event) {
        _vm.dadCheck($event)
      },
      "addtocart": function($event) {
        _vm.add($event)
      },
      "removeitem": function($event) {
        _vm.removeitem($event)
      },
      "endtransaction": _vm.endtransaction
    }
  })], 1), _vm._v(" "), (_vm.routeEnabled) ? _c('app-footer', {
    attrs: {
      "issessionset": _vm.sessionSet
    }
  }) : _vm._e(), _vm._v(" "), (_vm.routeEnabled) ? _c('app-copyright') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "login"
    }
  }, [_c('h1', [_vm._v("Log in")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Username"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "message"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Not yet a member? "), _c('router-link', {
    staticClass: "font-link floatright",
    attrs: {
      "to": "/account-selection"
    }
  }, [_vm._v("Sign up!")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Become our Supplier")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Post your products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications and feedbacks about your products")])])])
}]}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-r"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "text-left"
  }, [_vm._v("Receipt Order# " + _vm._s(_vm.ordercode))]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderinfo), function(order) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('router-link', {
      attrs: {
        "to": '/products/product/' + order.code,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(order.product_name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(order.category))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(order.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Php " + _vm._s(_vm.formatMoney(order.price)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearboth spacera"
  }), _vm._v(" "), _c('button', {
    staticClass: "button-type-h",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.exitReceipt
    }
  }, [_vm._v("Done")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price")])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "3em"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    }
  }, [_vm._v("Our Business Partners")]), _vm._v(" "), _c('div', {
    staticClass: " col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
  }, _vm._l((_vm.bps), function(bp, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-6 col-sm-4 col-md-3 bp"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/mybp/' + bp.img,
        "alt": bp.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bpc col-xs-12"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/bp/' + bp.img,
        "alt": bp.img
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "cta-section-2"
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Check out our products!")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-item about-history"
  }, [_c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12"
  }, [_c('h1', [_vm._v("Company History")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tEstablished in 1987, Mutual Success Lighting Fixture Inc., has maintained its position as a quality lighting provider in the industry.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tWith its over twenty-five (25) years of continuous innovation, customer service and excellence, the company relatively expanded, numerically evident by the availability of product lines in more than 200 major depots and DIY's nationwide.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tIt is the commitment to exceeding the needs of the household and construction industry that makes the company go further. The company ensures that its importation will give customers a wide array of lighting designs and functionalities at reasonable cost. As an observance to quality standards, the products are CE, ICC and DTI certified.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tMutual Success Lighting Fixture Inc. offers all types of lighting requirements. From ambient lighting to general lighting, from accent and task lighting to outdoor and industrial lighting; all of which have the objective of providing lighting needs and satisfaction essential to daily living.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12 pull-right"
  }, [_c('h1', [_vm._v("Vision")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tTo be a major player in the industry recognized for its pursuits of sustainability and principle.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12"
  }, [_c('h1', [_vm._v("Mission")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tTo be a one-stop quality lighting provider for the household and construction industry and go beyond customers' expectations through commitment to operational excellence, performance, innovation; customer-centrism and integrity.\n\t\t\t\t\t")])])])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "pcsp"
  }, [_c('h1', [_vm._v("Account Information - " + _vm._s(_vm.user.username))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v("Basic Information")]), _vm._v(" "), _c('p', [_vm._v("Name: " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v("Account-Type: Buyer")]), _vm._v(" "), (!_vm.showpw) ? _c('p', [_vm._v("Password: "), _c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ShowChangePW($event)
      }
    }
  }, [_vm._v("Change")])]) : _vm._e(), _vm._v(" "), (_vm.showpw) ? _c('form', {
    attrs: {
      "id": "changePassword"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.ChangePassword($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "old_pw"
    }
  }, [_vm._v("Enter Old Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "old_pw",
      "id": "old_pw"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_pw"
    }
  }, [_vm._v("Enter New Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "new_pw",
      "id": "new_pw"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm_new_pw"
    }
  }, [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "confirm_new_pw",
      "id": "confirm_new_pw"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.changepwtoken
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "floatright button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.user.email))]), _vm._v(" "), (!_vm.showmb) ? _c('p', [_vm._v("Mobile #: " + _vm._s(_vm.user.mobile_number) + " "), _c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ShowChangeMB($event)
      }
    }
  }, [_vm._v("Change")])]) : _vm._e(), _vm._v(" "), (_vm.showmb) ? _c('form', {
    attrs: {
      "id": "changeMobile"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.ChangeMobile($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "new_mb"
    }
  }, [_vm._v("Enter New Mobile Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "new_mb",
      "id": "new_mb"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "floatright button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('div', {
    staticClass: "notification-b"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.notificationMessage)
    }
  }), _vm._v(" "), _c('span')]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "id": "nav-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/logo.png",
      "alt": "Apollo Logo"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "nav-bar-mobile",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.mobileMenu($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/h.svg"
    }
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "nav-bar"
    }
  }, [(!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/adminproposal",
      "title": "proposalA"
    }
  }, [_vm._v("---")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/supplierproductproposal",
      "title": "proposalS"
    }
  }, [_vm._v("---")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/user"
    }
  }, [_vm._v("User")])], 1) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/about",
      "title": "about"
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/locations",
      "title": "locations"
    }
  }, [_vm._v("Locations")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta cta-link-perm",
    attrs: {
      "to": "/user"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])], 1) : _vm._e(), _vm._v(" "), (_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#",
      "title": "logout"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Log In")])], 1) : _vm._e(), _vm._v(" "), (!_vm.issessionset) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "cta cta-link-perm",
    attrs: {
      "to": "/account-selection"
    }
  }, [_vm._v("Sign Up!")])], 1) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('li', [_c('router-link', {
    staticClass: "cart-link",
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("Cart: " + _vm._s(_vm.cart))])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "how-to.php",
      "title": "suppliers"
    }
  }, [_vm._v("Suppliers")])])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v(_vm._s(_vm.date) + " Mutual Success Lighting Fixtures Inc.")])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding",
    attrs: {
      "id": "myproducts"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "text-justify"
    }, [_vm._v("Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.")]), _vm._v(" "), _c('p', [_vm._v("Status: Approved")])])
  })), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myproducts-options"
    }
  }, [_c('h1', [_vm._v("My Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search my Products"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wall Sconces")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Chandeliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pendants")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Undercabinet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ceiling")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Desk, Floor & Table Lamps")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Architectural")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recessed")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Unread")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Rejected")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta-section-2",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Load more products")])])
}]}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "the-overflow"
    }
  }, [_c('router-link', {
    staticClass: "button-type-f",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Go back to products")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border": "1px solid #efefef"
    },
    attrs: {
      "src": 'static/images/products/' + _vm.product_info.code + '.jpg',
      "alt": _vm.product_info.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v(_vm._s(_vm.product_info.name))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Category")]), _vm._v(" " + _vm._s(_vm.product_info.category))]), _vm._v(" "), (!_vm.disabled) ? _c('p', [_c('strong', [_vm._v("Price")]), _vm._v(" Php " + _vm._s(_vm.formatMoney(_vm.product_info.price)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product-data"
  }, [_c('h2', [_vm._v("Product Specs")]), _vm._v(" "), _c('ul', {
    staticClass: "product-specs"
  }, [_c('li', [_c('strong', [_vm._v("Materials")]), _vm._v(" " + _vm._s(_vm.product_info.materials))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Socket Type")]), _vm._v(" " + _vm._s(_vm.product_info.socket))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Best For:")]), _vm._v(" " + _vm._s(_vm.product_info.forplace))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("No. of Bulbs:")]), _vm._v(" " + _vm._s(_vm.product_info.numbulb))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.product_info.led))])])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "url('static/images/l.jpg') no-repeat center center",
      "background-size": "cover"
    },
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "register"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.buyerRegister($event)
      }
    }
  }, [_c('h3', [_vm._v("Account Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Full name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username",
      "placeholder": "username"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "email"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password_confirm"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password_confirm",
      "id": "password_confirm",
      "placeholder": "Confirm Password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mobile_number"
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "mobile_number",
      "id": "mobile_number",
      "placeholder": "Mobile Number"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.token
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "id": "message"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Buyer Registration")]), _vm._v(" "), _c('p', [_vm._v("this template currently applies for buyers")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Buy Apollo lighting fixture products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications reports about the products")])])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Subscribe to our Newsletter")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "newsletter"
    }
  }, [(_vm.show) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "type your email here"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Subscribe")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Our Credo")]), _vm._v(" "), _c('p', [_vm._v("If quality comes at a price, why does Apollo come handy? \n\t\t"), _c('br'), _c('br'), _vm._v("Because Apollo understands Because Apollo believes that suiting your senses is as important as suiting your mind.\n\t\t"), _c('br'), _c('br'), _vm._v("Because as Apollo meets your needs, so is its purpose.\n\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Contact Info")]), _vm._v(" "), _c('p', [_vm._v("Mutual Success Lighting Fixtures Inc.\n\t\t"), _c('br'), _vm._v("Suite 3003-A East Tower, PSE Center, Exchange Road, \n\t\t"), _c('br'), _vm._v("Ortigas Center, Pasig City\n\t\t"), _c('br'), _c('br'), _vm._v("\n\t\tLandline # (632) 687-7111\n\t\t"), _c('br'), _vm._v("Fax # (632) 687-7111 loc 5\n\t\t")])])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "overflow": "hidden",
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": 'static/images/products/' + _vm.item.code + '.jpg',
      "alt": _vm.item.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('button', {
    on: {
      "click": _vm.minq
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background": "transparent",
      "border": "2px solid #ccc"
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.counter))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addq
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("\n\t\tPhp " + _vm._s(_vm.formatMoney(_vm.iteminfo.total)) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "title": "removeitem"
    },
    on: {
      "click": _vm.removeitem
    }
  }, [_vm._v("Remove Item")])])])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item-admin"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Purchase Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Product"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wall Sconces")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Chandeliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pendants")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Undercabinet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ceiling")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Desk, Floor & Table Lamps")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Architectural")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recessed")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Suppliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Supplier: "), _c('strong', [_vm._v("Phelix Systems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")]), _vm._v(" "), _c('small', [_vm._v("FOB")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-purchase-options"
  }, [_c('button', {
    staticClass: "col-md-6"
  }, [_vm._v("View Product")]), _vm._v(" "), _c('button', {
    staticClass: "col-md-6"
  }, [_vm._v("Add to Cart")])])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-padding page-content-bg-a",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "accountselect"
    }
  }, [_c('h1', [_vm._v("Choose your Apollo Account. Sign up is free!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "accountselectrow"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "account-type"
  }, [_c('h1', [_vm._v("Buy Apollo Products")]), _vm._v(" "), _c('p', [_vm._v("For people who want to buy apollo lighting fixtures")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-g",
    attrs: {
      "to": "/registration/buyer"
    }
  }, [_vm._v("Get Started")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Buy all kinds of lighting fixtures from Apollo")]), _vm._v(" "), _c('li', [_vm._v("Other information that can be used to promote this feature")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "account-type"
  }, [_c('h1', [_vm._v("Be a supplier of Apollo")]), _vm._v(" "), _c('p', [_vm._v("For people who want be a supplier of Apollo")]), _vm._v(" "), _c('button', {
    staticClass: "button-type-g button-type-g-disabled",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Coming Soon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Buy all kinds of lighting fixtures from Apollo")]), _vm._v(" "), _c('li', [_vm._v("Other information that can be used to promote this feature")]), _vm._v(" "), _c('li', [_vm._v("Propose products to Apollo")]), _vm._v(" "), _c('li', [_vm._v("Get paid by Apollo to be something information to be part here")])])])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-b"
  }, [_c('p'), _vm._v(" "), _c('span')])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "adminsidebar"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/adminproposal"
    }
  }, [_vm._v("New Proposals")])], 1), _vm._v(" "), _c('li', [_vm._v("View Cart")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminpurchase"
    }
  }, [_vm._v("Purchase Products")])], 1), _vm._v(" "), _c('li', [_vm._v("Order Status")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminsuppliers"
    }
  }, [_vm._v("Suppliers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminsupplieritems"
    }
  }, [_vm._v("Supplier Products")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_vm._v("Monitoring Options")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adminproducts"
    }
  }, [_vm._v("Apollo Products")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "400px",
      "width": "100%",
      "background": "#ccc",
      "position": "relative"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "searchbox"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "search Apollo locations",
      "id": "search"
    },
    on: {
      "change": _vm.search,
      "keyup": _vm.search
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "locationlist"
    }
  }, _vm._l((_vm.locationlist), function(location) {
    return _c('li', {
      attrs: {
        "lat": location.lat,
        "lng": location.lng
      },
      domProps: {
        "textContent": _vm._s(location.name.toLowerCase())
      },
      on: {
        "click": _vm.center
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suppliersidebar"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproductproposal"
    }
  }, [_vm._v("Propose a Product")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproducts"
    }
  }, [_vm._v("My Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproduct"
    }
  }, [_vm._v("A Product")])], 1), _vm._v(" "), _c('li', [_vm._v("Product Orders")])])])
},staticRenderFns: []}

/***/ })
]),[76]);


// WEBPACK FOOTER //
// static/js/app.67f9d5dc4fd28501acee.js